import type { TemplateScalarVariable } from "./TemplatesForm.types";
import css from "./VariableSidebar.module.scss";
import { type ScalarGroup, TYPE_BADGE } from "./VariableSidebar.utils";

interface Props {
  groups: ScalarGroup[];
  disabled: boolean;
  onPick: (variable: TemplateScalarVariable) => void;
}

// Категоризованный список scalar-переменных. Каждый чип-кнопка вставляет свой
// placeholder в редактор на текущую позицию каретки.
export const ScalarVariableList = ({ groups, disabled, onPick }: Props) => (
  <>
    {groups.map((group) => (
      <section key={group.categoryKey} className={css.section}>
        <div className={css.sectionTitle}>{group.label}</div>
        <div className={css.chipGrid}>
          {group.vars.map((variable) => (
            <button
              key={variable.key}
              type="button"
              className={css.chip}
              onClick={() => onPick(variable)}
              disabled={disabled}
              title={
                variable.example
                  ? `Пример: ${variable.example}`
                  : variable.placeholder
              }
            >
              <span className={css.chipLabel}>{variable.label}</span>
              <span className={css.chipMeta}>
                <span className={css.chipKey}>{variable.key}</span>
                <span className={css.chipType}>
                  {TYPE_BADGE[variable.type] ?? variable.type}
                </span>
              </span>
            </button>
          ))}
        </div>
      </section>
    ))}
  </>
);
